<script>
  export let set
  export let seti

  import WorkoutPlanSetExerciseWidget from './WorkoutPlanSetExerciseWidget.svelte'
</script>

<div class="card">
  <div class="card-header d-flex align-items-center">
    <span class="me-auto">Set {seti + 1}</span>
  </div>
  <ul class="list-group list-group-flush">
    {#each set.exercises as exercise (exercise.id)}
      <WorkoutPlanSetExerciseWidget {exercise} />
    {/each}
  </ul>
</div>
